// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"Input_styledInput__1qtjR","error":"Input_error__xAy6a"};